// Multivariate Dependencies
import React, { useRef, useEffect } from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { Icon } from '../../../atoms/Icon';
import { IconButton } from '../../../atoms/IconButton';
import { TextButton } from '../../../atoms/TextButton';
// Types
import { SearchBarAttributes } from '../types/SearchBarProps';
export var SearchBarStructure = function (_a) {
    var prefixIcon = _a.prefixIcon, placeholderText = _a.placeholderText, className = _a.className, textButtonLabel = _a.textButtonLabel, value = _a.value, maxLength = _a.maxLength, autoFocus = _a.autoFocus, onEnter = _a.onEnter, onEscape = _a.onEscape, onInputChange = _a.onInputChange, onClose = _a.onClose, onTextButtonClick = _a.onTextButtonClick;
    var inputRef = useRef(null);
    useEffect(function () {
        if (autoFocus) {
            inputRef.current.focus();
        }
        // this is to only make it occur on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var runHandlerByPressedKey = function (event) {
        if (event.key === 'Enter' && onEnter) {
            onEnter(event);
        }
        if (event.key === 'Escape' && onEscape) {
            event.preventDefault();
            onEscape(event);
        }
    };
    return (React.createElement(Container, { className: className },
        prefixIcon && React.createElement(Icon, { name: prefixIcon, ariaLabel: prefixIcon, styleVariant: 'grey' }),
        React.createElement("input", { ref: inputRef, type: 'search', placeholder: placeholderText, onChange: onInputChange, onKeyDown: runHandlerByPressedKey, value: value, maxLength: maxLength }),
        onClose && (React.createElement(IconButton, { size: 'small', icon: 'Xmark', ariaLabel: SearchBarAttributes.ICON_BUTTON_LABEL, onClick: onClose, styleVariant: 'ghost' })),
        textButtonLabel && value && (React.createElement(TextButton, { size: 'small', styleVariant: 'subtle', onClick: onTextButtonClick }, textButtonLabel))));
};
//# sourceMappingURL=SearchBarStructure.js.map